<div class="datepicker-trigger" [class.focused]="picker.opened" (click)="open()">
  <input matInput [matDatepicker]="picker" class="hide" [(ngModel)]="selectedDate" (ngModelChange)="dateUpdated()" />
  <mat-datepicker #picker (closed)="focusChange.emit(false)"></mat-datepicker>

  <!--  ICON -->
  <div class="f-icon icon-date-picker"></div>

  <!-- Placeholder -->
  <div *ngIf="!selectedDate; else singleLabel" class="placeholder">
    <ng-container *ngIf="placeholder; else defaultPlaceholder">
      {{ placeholder }}
    </ng-container>
    <ng-template #defaultPlaceholder>
      {{ 'ui2-datepicker.inputPlaceholderRange' | translate }}
    </ng-template>
  </div>

  <!-- Label -->
  <ng-template #singleLabel>
    <div class="label">{{ selectedDate | date : 'MMM d, y' }}</div>
  </ng-template>

  <!-- Clear button -->
  <div *ngIf="clearable && selectedDate" class="icon2-x16-close-s" (click)="clear(); $event.stopPropagation()"></div>

  <!-- CHEVRON
    we show either one or another with CSS
  -->
  <!-- normal -->
  <div class="icon2-x16-chevron-l" [class.open]="picker.opened"></div>
  <!-- micro -->
  <div class="icon2-x16-micro-chevron-m" [class.open]="picker.opened"></div>
</div>
